import { post } from '../api';
import { Crypto } from '@utils';

export const login = (username, password) => {
  return post('/api/login', {
    username,
    password: Crypto.SHA256(password),
  });
};
